var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTopWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_2674)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0952 8.57159V11.4287C18.0952 12.1338 17.7122 12.7493 17.1428 13.0787V15.2383C17.1428 16.2902 16.2901 17.143 15.2381 17.143H3.80952C2.75755 17.143 1.90475 16.2902 1.90475 15.2383V4.76206C1.90475 3.71009 2.75755 2.8573 3.80952 2.8573H15.2381C16.2901 2.8573 17.1428 3.71009 17.1428 4.76206V6.92165C17.7122 7.25099 18.0952 7.86655 18.0952 8.57159ZM5.71427 5.7144C5.18828 5.7144 4.76189 6.14079 4.76189 6.66678C4.76189 7.19276 5.18828 7.61916 5.71427 7.61916H13.3333C13.8593 7.61916 14.2857 7.19276 14.2857 6.66678C14.2857 6.14079 13.8593 5.7144 13.3333 5.7144H5.71427ZM13.3333 11.4286C13.8593 11.4286 14.2857 11.0022 14.2857 10.4762C14.2857 9.9502 13.8593 9.5238 13.3333 9.5238C12.8074 9.5238 12.381 9.9502 12.381 10.4762C12.381 11.0022 12.8074 11.4286 13.3333 11.4286Z",
    fill: "#F9DF35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_2674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopWallet);
export default __webpack_public_path__ + "static/media/icon_top_wallet.d9ecb001cf94b26e3661b796dc12b629.svg";
export { ForwardRef as ReactComponent };